import { render } from "./HeroiconsSolidReply.vue?vue&type=template&id=6201766b"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidReply.vue"]])

export default __exports__